$(function() {
  if($('#tab_nav').length) {
    var tab_btn = $("#tab_nav li");
    var tab = $("#tab_body .tab_box");
    tab_btn.on('click', function (e) {
      var index = $(this).index();
      if (!$(this).hasClass("active")) {
        tab_btn.removeClass("active");
        $(this).addClass("active");
        tab.removeClass("active");
        tab.eq(index).addClass("active");
      }
      e.preventDefault();
    });
  }
});
$(window).on('load',function(){
  var urlHash = location.hash;
  console.log(urlHash);
  if (urlHash) {
    // $('body,html').stop().scrollTop(0);
    var number = $("#tab_body .tab_box" + urlHash).index();
    console.log(number);
    console.log(urlHash);
    $('#tab_nav li, #tab_body .tab_box').removeClass('active');
    $(urlHash).addClass("active");
    $("#tab_nav li").eq(number).addClass("active");
  }
});